var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0V6C11 7.10457 11.8954 8 13 8H19V18C19 19.1046 18.1046 20 17 20H10.1904C11.3112 18.8321 12 17.2465 12 15.5C12 11.9101 9.08985 9 5.5 9C4.6141 9 3.76959 9.17723 3 9.49816V2C3 0.895431 3.89543 0 5 0H11ZM12.5 0.5V6C12.5 6.27614 12.7239 6.5 13 6.5H18.5L12.5 0.5ZM11 15.5C11 12.4624 8.53757 10 5.5 10C2.46243 10 0 12.4624 0 15.5C0 18.5376 2.46243 21 5.5 21C8.53757 21 11 18.5376 11 15.5ZM6.00065 16L6.00111 18.5035C6.00111 18.7797 5.77725 19.0035 5.50111 19.0035C5.22497 19.0035 5.00111 18.7797 5.00111 18.5035L5.00065 16H2.4956C2.21973 16 1.99609 15.7762 1.99609 15.5C1.99609 15.2239 2.21973 15 2.4956 15H5.00046L5 12.4993C5 12.2231 5.22386 11.9993 5.5 11.9993C5.77614 11.9993 6 12.2231 6 12.4993L6.00046 15H8.49659C8.77246 15 8.99609 15.2239 8.99609 15.5C8.99609 15.7762 8.77246 16 8.49659 16H6.00065Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/files-icon.3476fa2a174a652209199a6be0113486.svg";
export { ForwardRef as ReactComponent };